import { render, staticRenderFns } from "./layoutA.vue?vue&type=template&id=ff9011aa&scoped=true&"
import script from "./layoutA.vue?vue&type=script&lang=js&"
export * from "./layoutA.vue?vue&type=script&lang=js&"
import style0 from "./layoutA.vue?vue&type=style&index=0&id=ff9011aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff9011aa",
  null
  
)

export default component.exports